import { configureApi } from '@scc/lib'
import { useSessionStore } from '@/lib/session.store'
import { routeRequestFor } from '@/lib/portal-routing'

// On refresh failure, clear the one session (auth-unification U2) — the
// caller (use-session-bootstrap's subscription, or a portal component's own
// 401 handler) is responsible for routing to /login.
//
// The refresh cookie is single-use, so a sibling tab can win a refresh race
// and rotate it out from under a request that's already in flight here. That
// request's failure is stale, not a real logout — only clear the session if
// the token that failed is still the one we're holding; if it isn't, another
// tab already replaced it with a good one and there's nothing to do.
configureApi({
  baseUrl: import.meta.env.VITE_API_BASE_URL ?? 'http://localhost:3001/api/v1',
  getToken: () => useSessionStore.getState().token,
  // A signed-in client's reads of the staff pages go to their portal copies.
  routeRequest: routeRequestFor(() => useSessionStore.getState().token),
  setToken: (t) => useSessionStore.getState().setToken(t),
  onAuthFailure: (failedToken) => {
    if (useSessionStore.getState().token === failedToken) {
      useSessionStore.getState().clearSession()
    }
  },
})
